import {
  ORIGIN_REQUEST_LOGIN,
  ORIGIN_REQUEST_RESET,
  RESET_PATH_REGEX,
} from '@/blocks/Auth/definitions'

const MISSING_REQUIRED_FIELD = 100
const FORBIDDEN = 107
const UNAUTHORIZED = 114
const INVALID_PASSWORD = 1013
const LIMIT_REACHED = 1021
const TOO_MANY_ATTEMPTS = 1023
const POLICY_CONSTRAINTS = 1062
const NEW_PASSWORD_MUST_BE_DIFFERENT_FROM_CURRENT = 1063
const NEW_PASSWORD_MUST_BE_DIFFERENT_FROM_PREVIOUS = 1065
const TOKEN_ID_NOT_FOUND = 6092

const resolveRequestOrigin = (path) => {
  const regex = new RegExp(RESET_PATH_REGEX)
  return regex.test(path) ? ORIGIN_REQUEST_RESET : ORIGIN_REQUEST_LOGIN
}

export const useErrorHandler = (error) => {
  if (!error) return
  let errorMessage = ''
  let requestOrigin = ''
  const serverErrorCode = error?.response?.data?.length
    ? error.response.data[0].Code
    : 0

  switch (serverErrorCode) {
    case MISSING_REQUIRED_FIELD:
      errorMessage = 'error.resetPassword.missing_field'
      break
    case UNAUTHORIZED:
      errorMessage = 'error.resetPassword.unauthorized'
      break
    case FORBIDDEN:
      errorMessage = 'error.resetPassword.forbidden'
      break
    case INVALID_PASSWORD:
      requestOrigin = resolveRequestOrigin(error.config?.url)
      if (requestOrigin === ORIGIN_REQUEST_LOGIN) errorMessage = 'error.login.invalid_password'
      else errorMessage = 'error.resetPassword.invalid_password'
      break
    case LIMIT_REACHED:
    case TOO_MANY_ATTEMPTS:
      errorMessage = 'error.login.too_many_attempts'
      break
    case POLICY_CONSTRAINTS:
      errorMessage = 'error.resetPassword.policy_constraints'
      break
    case NEW_PASSWORD_MUST_BE_DIFFERENT_FROM_PREVIOUS:
    case NEW_PASSWORD_MUST_BE_DIFFERENT_FROM_CURRENT:
      errorMessage =
        'error.resetPassword.new_pass_must_be_different_from_previous'
      break
    case TOKEN_ID_NOT_FOUND:
      errorMessage = 'error.resetPassword.expired_token'
      break
    default:
      errorMessage = 'error.resetPassword.general'
      break
  }
  return { ...error, message: errorMessage }
}
